import { useGenders } from '@/hooks/use-genders';
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SxProps,
    Theme,
} from '@rhg/libs/material';
import { Control, Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { ageGenderMessages } from '../messages';

interface GenderSelectProps {
    control: Control<any>;
    sx?: SxProps<Theme>;
}

const genderSelectId = 'genderSelect';
const genderSelectLabelId = 'genderSelectLabel';
export const GenderSelect = ({ control, sx }: GenderSelectProps) => {
    const { formatMessage } = useIntl();
    const { genders } = useGenders();

    return (
        <Controller
            name="gender"
            control={control}
            render={(props) => (
                <FormControl variant="filled" fullWidth sx={sx}>
                    <InputLabel
                        id={genderSelectLabelId}
                        htmlFor={genderSelectId}
                    >
                        {formatMessage(ageGenderMessages.genderSelectLabel)}
                    </InputLabel>
                    <Select
                        labelId={genderSelectLabelId}
                        inputProps={{ id: genderSelectId }}
                        aria-labelledby={genderSelectId}
                        value={props.field.value || ''}
                        onChange={props.field.onChange}
                    >
                        {/* TODO: In EVE-8765, add analytics to MenuItem buttons */}
                        {Object.values(genders).map(({ key, displayName }) => (
                            <MenuItem
                                key={key}
                                value={key}
                                trackButton="DoNotAgree"
                            >
                                {displayName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        ></Controller>
    );
};
